// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__38jKN","footer":"ModalUpdate_footer__1oylF"};